import { render, staticRenderFns } from "./calendar-event-notification.vue?vue&type=template&id=c53a3454&scoped=true"
import script from "./calendar-event-notification.vue?vue&type=script&lang=js"
export * from "./calendar-event-notification.vue?vue&type=script&lang=js"
import style0 from "./calendar-event-notification.vue?vue&type=style&index=0&id=c53a3454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53a3454",
  null
  
)

export default component.exports